import { Badge, type Tone } from '@/shared/ui/Badge';

import { QUOTE_STATUS_LABELS, type QuoteStatus } from './types';

/**
 * The four states of a quote, one colour each: a draft is work in progress (amber), an
 * approved one is done (green), a sent one is out of our hands (blue), a cancelled one
 * is nothing (neutral). Red is not used here: no state of a quote is an incident.
 */
const TONES: Record<QuoteStatus, Tone> = {
  draft: 'warn',
  reviewed: 'ok',
  sent: 'info',
  cancelled: 'neutral',
};

export function QuoteStatusBadge({ status }: { status: QuoteStatus }) {
  return (
    <Badge tone={TONES[status]} dot>
      {QUOTE_STATUS_LABELS[status]}
    </Badge>
  );
}
